import { Chip } from "@heroui/react";
import { ChipRemoveButton } from "./ChipRemoveButton";

interface RecipeTypeChipProps {
    name: string;
    onRemove?: () => void;
}

export const RecipeTypeChip = ({ name, onRemove }: RecipeTypeChipProps) => {
    const isRemovable = !!onRemove;
    return (
        <Chip
            size={isRemovable ? "md" : "lg"}
            variant={isRemovable ? "soft" : undefined}
            className={`chip--primary${isRemovable ? " active-filter-chip" : ""}`}
        >
            <Chip.Label>{name}</Chip.Label>
            {onRemove && <ChipRemoveButton label={name} onPress={onRemove} />}
        </Chip>
    );
};
